import Nav from '@/components/Nav';
import { Card, CardContent, Grid } from '@material-ui/core';
import React from 'react';
import ChangePlan from './Account/components/ChangePlan';
import ChangePaymentMethod from './Account/components/ChangePaymentMethod';

import './Account/Account.styles.scss';

export default function NoSub() {
  return (
    <div className="Account">
      <title>No Subscription</title>
      <Nav>
        <div className="content">
          <div className="liner">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <ChangePlan locale={{ currency: 'USD' }} />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12}>
                <Card>
                  <CardContent>
                    <ChangePaymentMethod locale={{ currency: 'USD' }} />
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </div>
        </div>
      </Nav>
    </div>
  );
}
